import CallToAction from "@/components/Button";
import { SVGDownload } from "@/lib/svg";
import { forwardRef } from "react";
import styled from "styled-components";

const _Button = forwardRef<HTMLAnchorElement, any>((props, ref) => (
  <CallToAction
    as="a"
    ref={ref}
    variant="primaryBoxed"
    {...props}
    icon={<SVGDownload />}
  />
));

_Button.displayName = "Button";

export const Button = styled(_Button)`
  max-width: max-content;
  margin-top: 1.5rem;
  ${({ theme }) => theme.mediaQueries.laptop} {
    margin-top: 0;
  }
`;
